module.exports = __webpack_public_path__ + "static/media/PM104.55732907.JPG";